<!--
Author: XiangChenYu
Date: 2019-10-24
Desc: 我的持仓列表组件，由index.js 配置引入
-->
<template>
    <div :class="'view-assets view ' + className">
        <comp-title :title="title" />
        <el-row v-if="planNum+assetsNum+privateNum+orderNum > 0" class="risk-change">
            <div class="risk-change-box">
                <i class="fa fa-exclamation-triangle" />
                <div class="risk-change-mes">
                    <p>
                        由于您的个人风险等级或产品风险等级变动，存在<span class="red">（{{ planNum+assetsNum+privateNum+orderNum }}）</span>笔产品风险等级高于您的风险承受能力的交易，请阅读风险警示进行适当性处理。
                    </p>
                    <p class="red">
                        对于未处理的定期投资协议或预约交易，将不产生定投交易或预约交易申请。
                    </p>
                </div>
            </div>
        </el-row>
        <el-tabs v-model="activeName" class="bg-white b-most">
            <el-tab-pane name="first" class="fund-arr">
                <el-badge slot="label" :hidden="assetsNum === 0" :value="assetsNum" class="item">
                    我的持仓
                </el-badge>
                <asset-fund :fund-info="fundInfo" :fund-cate="0" :show-list="showList" :is-risk="assetsNum" v-on:fund-continue="fundCon" />
            </el-tab-pane>
            <!-- <el-tab-pane v-if="this.$cache.getStatus('GDLC') == '1'" label="" name="second" class="fund-arr">
                <el-badge slot="label" :hidden="privateNum === 0" :value="privateNum" class="item">
                    高端理财
                </el-badge>
                <asset-fund :fund-info="privateInfo" :fund-cate="1" :is-risk="privateNum" v-on:fund-continue="fundCon" />
            </el-tab-pane> -->
        </el-tabs>
        <risk-dialog :fund="fundDetail" v-on:event-fn="backFn" />
        <msg-dialog v-if="dialog" :dialog="dialog" :private-info="wisdomInfo" v-on:event-fn="backFn" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import assetFund from "@/components/fund/assetFund";
import riskDialog from "@/components/misc/riskDialog";
import msgDialog from "@/components/misc/msgDialog";
export default {
    name: "AssetsList",
    components: {
        assetFund,
        riskDialog,
        msgDialog
    },
    mixins: [mixin],
    data () {
        return {
            activeName: "first",
            gfund: [],
            fundInfo: [],
            privateInfo: [],
            orderInfo: [],
            expands: [],
            assetsNum: 0,
            dialog: false,
            planNum: 0,
            privateNum: 0,
            orderNum: 0,
            fundDetail: {},
            xjbCode: "",
            lowriskflag: "0",
            wisdomInfo: {},
            showList: false
        };
    },
    created () {
        this.xjbCode = this.$cache.getXjbCode();
        this.lowriskflag = this.$cache.getUser().lowriskflag;
        this.getFundLists();
    },
    methods: {
        formatterDate (row, column, value) {
            return this.$util.fmtDate(value);
        },
        // 适当性基金信息校验
        fundCon (way, fund) {
            const _this = this;
            if (way === "24") {
                const _fund = _this.$util.dataTaacFilter(fund);
                const _x = Object.assign({}, _fund, { way: way });
                sessionStorage.setItem("sellfund", JSON.stringify(_x));
                this.$router.push({ name: "sellfund", query: { fundcode: _fund.fundcode } });
            } else {
                let _url = "";
                // 购买
                if (way === "20,22") {
                    // 普通购买/定投
                    fund.proto = "plan";
                    this.$util.fundRiskCheck(this, fund, res => {
                        if (res) {
                            const _x = Object.assign({}, res, { way: way });
                            _url = fund.fundtype === "4" ? "privatebuy" : "buyfund";
                            if (fund.fundtype === "4") {
                                _this.$util.request("pef/trade/prdlist", { fundcode: fund.fundcode }).then(pef => {
                                    if (pef.data) {
                                        const _y = Object.assign({}, _x, pef.data[0][0]);
                                        sessionStorage.setItem(_url, JSON.stringify(_y));
                                        _this.$router.push({ name: _url, query: { fundcode: _y.fundcode } });
                                    }
                                });
                            } else {
                                sessionStorage.setItem(_url, JSON.stringify(_x));
                                _this.$router.push({ name: _url, query: { fundcode: _x.fundcode } });
                            }
                        }
                    });
                    //   阅读适当性协议
                } else if (way === "P4" || way === "P5" || way === "P8") {
                    this.fundDetail = Object.assign({}, fund, { way: way });
                } else if (way === "G1,P8" || way === "60,P5") { // 定投协议暂停和终止
                    this.btnAction(fund, way);
                }
            }
        },
        // 获取基金名称显示
        getFundName (val, flag) {
            let _k = "";
            let _m = ",";
            if (!flag) {
                _m = "<br/>";
                if (val.busitype === "7" || val.planpaytype === "2") {
                    _k = "<b class=\"wisdom-icon\" title=\"现金宝\">现</b>";
                }
            }
            if (val.fundcode.indexOf(",") === -1) {
                return _k + val.fundname + "(" + val.fundcode + ")";
            }
            const _x = val.fundcode.split(",");
            const _y = val.fundname.split(",");
            let _z = "";
            // 定转显示
            for (let i in _x) {
                _z += _k + _y[i] + "(" + _x[i] + ")" + _m;
            }
            if(val.buyplanname != "") {
                _z = _k + val.buyplanname;
            }
            return _z;
        },
        // 按钮响应处理
        btnAction (fund, way) {
            let _x = {};
            if (way === "G1,P8") {
                _x.cateText = "暂停";
                _x.opertype = "1";
            } else if (way === "60,P5") {
                _x.cateText = "终止";
                _x.opertype = "2";
            }
            _x.way = way;
            const _y = this.getFundName(fund, true);
            _x.msg = "您确定执行" + _y + _x.cateText + "定投协议操作？";
            _x.tit = _x.cateText + "定投协议提示";
            _x.btn1 = "确认" + _x.cateText;
            _x.btn2 = "取消";
            this.wisdomInfo = Object.assign({}, fund, _x);
            this.dialog = true;
        },
        // 适当性处理
        backFn (val) {
            const _this = this;
            this.dialog = false;
            if (val) {
                const _data = {
                    serialno: val.serialno,
                    busitype: val.busitype,
                    chgtype: val.chgtype,
                    opertype: val.opertype,
                    fundcode: val.fundcode,
                    riskwarnflag: val.riskwarnflag,
                    riskmismatchflag: val.riskmismatchflag,
                    highriskwarnflag: val.highriskwarnflag,
                    fundmismatchflag: val.fundmismatchflag,
                    saveplanflag: val.saveplanflag,
                    tradepwd: val.tpasswd
                };
                this.$util.request("acct/sdx/readwarn", _data, "POST").then(res => {
                    if (res.data) {
                        //针对预约协议处理
                        if (val.busitype === "4") {
                            _this.orderInfo.forEach((item, index) => {
                                if (item.serialno === val.serialno) {
                                    _this.$set(_this.orderInfo[index], "iswarn", "0");
                                }
                            });
                            /* _this.orderInfo = _this.orderInfo.filter( e => {
                                return e.serialno !== val.serialno;
                            }); */
                            _this.orderNum--;
                            return false;
                        }
                        //针对非预约协议处理
                        _this.updateData(val);
                    }
                });
            }
        },
        // 更新列表信息
        updateData (val) {
            let _index = -1;
            let _x = [];
            if (val.planflag) {
                _x = this.gfund;
            } else {
                if (val.fundtype === "4") {
                    _x = this.privateInfo;
                } else {
                    _x = this.fundInfo;
                }
            }
            _x.forEach((item, index) => {
                if (item.serialno === val.serialno) {
                    item.iswarn = "0";
                    // 暂停和终止属性修改
                    if (val.opertype === "1") {
                        item.status = "P";
                    } else if (val.opertype === "2") {
                        item.status = "C";
                    }
                    _index = index;
                    if (val.planflag) {
                        this.planNum--;
                    } else {
                        val.fundtype === "4" ? this.privateNum-- : this.assetsNum--;
                    }
                }
            });
            if (_index === -1) return;
            if (val.planflag) {
                this.$set(this.gfund, _index, _x[_index]);
            } else {
                if (val.fundtype === "4") {
                    this.$set(this.privateInfo, _index, _x[_index]);
                    return;
                }
                //针对在途
                if (val.busitype === "1"){
                    this.fundInfo = this.fundInfo.filter(e => {return e.serialno !== val.serialno;});
                    return;
                }
                this.$set(this.fundInfo, _index, _x[_index]);
            }
        },
        // 风险协议变动处理 s终止 c继续 p暂停 a重新评测
        riskBtnCheck (val) {
            if (val.chgtype === "0") {
                if (this.lowriskflag === "1" && val.risklevel > "01") {
                    return "s";
                } else {
                    if (val.planflag === "a" || val.planflag === "b") {
                        return "c,s";
                    }
                    return "c,p,s";
                }
            } else if (val.chgtype === "1") {
                if (this.lowriskflag === "1") {
                    return "a,s";
                } else {
                    if (val.planflag === "a" || val.planflag === "b") {
                        return "c,s";
                    }
                    return "c,p,s";
                }
            }
        },
        // 获取资产信息
        getFundLists () {
            const _this = this;
            this.showList = true;
            this.$util.request("acct/asset/detail").then(res => {
                if (res.data && res.data[1]) {
                    _this.fundInfo = _this.$util.getCodeOnly(res.data[0].concat(res.data[2]), { code: "fundcode", noFilter: "busitype", noFilterVal: "1", data: ["marketvalue", "costmoney", "floatprofit", "totalincome", "holdincome", "addincome", "appamount", "availablevol", "frozenvol", "balancevol"] });
                    // _this.privateInfo = _this.$util.getCodeOnly(res.data[2], { code: "fundcode", noFilter: "busitype", noFilterVal: "1", data: ["marketvalue", "costmoney", "floatprofit", "totalincome", "holdincome", "addincome", "appamount", "availablevol", "frozenvol", "balancevol"] });
                    // _this.gfund = res.data[1];
                    // 合并组合定投基金
                    /*_this.gfund = _this.$util.getCodeOnly(_this.gfund, { code: "mainplanno", data: ["fundname", "fundcode", "risklevel", "firstinvestamount", "planno"] }, ",");
                    _this.gfund.forEach(item => {
                        item.action = "";
                        if (item.iswarn === "1" && ("2,3,4,6,7".indexOf(item.busitype) > -1)) {
                            item.action = _this.riskBtnCheck(item);
                            ++_this.planNum;
                        }
                    });*/
                    _this.fundInfo.forEach(item => {
                        if (item.iswarn === "1" && (item.busitype === "0" || item.busitype === "1")) {
                            ++_this.assetsNum;
                        }
                    });
                    /*_this.privateInfo.forEach(item => {
                        if (item.iswarn === "1" && (item.busitype === "0" || item.busitype === "1")) {
                            ++_this.privateNum;
                        }
                    });*/
                    const _x = res.data[3] || [];
                    _this.orderInfo = _x.filter(e => {return e.iswarn === "1";});
                    _this.orderNum = _this.orderInfo.length;
                    _this.showList = false;
                }
            });
        }
    }
};
</script>
<style lang="scss">
.view-assets {
    .risk-change {
        margin: 0 0 10px;
        .risk-change-box {
            padding: 8px 44px;
            background-color: #fef0f0;
            border-radius: 4px;
            position: relative;
            line-height: 26px;
            .fa-exclamation-triangle {
                position: absolute;
                left: 22px;
                top: 14px;
                color: #e94841;
            }
            .red {
                color: #e94841;
            }
        }
    }
    .wisdom-icon {
        font-size: 12px;
        display: inline-block;
        font-style: normal;
        background-color: #e94841;
        color: #ffffff;
        width: 18px;
        height: 18px;
        line-height: 18px;
        vertical-align: middle;
        text-align: center;
        border-radius: 50%;
        margin-right: 4px;
    }
    .el-tabs__header {
        margin: 0;
    }
    .el-tabs__nav-wrap:after {
        background: #ebebeb;
        height: 1px;
    }
    .el-tabs__nav-scroll {
        line-height: 50px;
        padding: 0 20px;
        .el-tabs__active-bar {
            background: #eba100;
        }
        .el-tabs__item {
            font-size: 18px;
            &.is-active {
                color: #eba100;
            }
            .el-badge__content.is-fixed {
                top: 10px;
                right: 1px;
            }
        }
    }
    .el-tabs__content {
        padding: 0 0 20px;
        .fund-offset .cell {
            padding: 0 10px 0 20px;
        }
        .fund-arr {
            padding: 0 20px;
            .cell {
                padding: 0;
            }
        }
    }
    .prompt-info {
        .el-icon-warning {
            color: #eba100;
            margin-right: 8px;
            font-size: 24px;
            vertical-align: middle;
        }
        span {
            vertical-align: middle;
        }
    }
    .el-table__expand-icon {
        margin-top: 20px;
    }
    .order-table {
        .is-right.is-leaf {
            text-align: center;
        }
        td.is-right .cell {
            padding-right: 40px;
        }
    }
}
</style>
